export const ENDPOINTS_RESULTS = {
  ATTEMPS_ID: '/bff-vle/attempts/:attemptId',
  DELETE_TEACHER_COMMENT: '/bff-vle/results/teacherComment/:teacherCommentId',
  RESULTS: '/bff-vle/results',
  RESULTS_HIDE_GRADE: '/bff-vle/results/hide',
  RESULTS_TEACHER_COMMENT: '/bff-vle/results/teacherComment',
  STUDENTS_ID_BOOKS_ID_COLUMNS_ID_RESULTS:
    '/bff-vle/students/:studentGuid/books/:bookId/columns/:columnGuid/results',
  UPDATE_TEACHER_GRADE_RESULTS: '/bff-vle/results',
  UPDATE_TEACHER_GRADE_TO_GRADE: '/bff-vle/results/teacherGrade',
}
